import { put, takeEvery } from 'redux-saga/effects';

import { SEND_EVENT } from './druid/actions/sendEvent';
import postActivity from './druid/actions/postActivity';
import whileConnected from '/druid/effects/whileConnected';

function* postActivityWithEvent({ payload: { name, value } }) {
  yield put(
    postActivity({
      name,
      type: 'event',
      value
    })
  );
}

function* sendEventToPostActivity() {
  yield takeEvery(({ payload, type }) => type === SEND_EVENT && payload.name, postActivityWithEvent);
}

export default function* sendEventToPostActivitySaga() {
  yield whileConnected(sendEventToPostActivity);
}
